/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiFormRuleType;
(function (ApiFormRuleType) {
    ApiFormRuleType["INPUT"] = "INPUT";
    ApiFormRuleType["SEARCH_PARAM"] = "SEARCH_PARAM";
    ApiFormRuleType["FILE"] = "FILE";
})(ApiFormRuleType || (ApiFormRuleType = {}));
export function ApiFormRuleTypeFromJSON(json) {
    return ApiFormRuleTypeFromJSONTyped(json, false);
}
export function ApiFormRuleTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiFormRuleTypeToJSON(value) {
    return value;
}
